import React from "react";
import { HStack, Modal } from "native-base";
import { getDir, getIsRTL } from "../util";

const ModalBase = (props: any) => {
  const { header, children, footer, closeButton = true } = props;
  return (
    <Modal style={{ direction: getDir() }} {...props} size="xl">
      <Modal.Content
        // w="full"
        // maxWidth={{ base: "85%", md: "40%" }}
        maxHeight="80%"
        // {...contentStyle}
      >
        <HStack
          justifyContent="space-between"
          w="100%"
          alignItems="flex-start"
          flexDirection="row-reverse"
        >
          {closeButton && (
            <Modal.CloseButton
              mx={getIsRTL() ? "20px" : "0"}
              position="relative"
            />
          )}
          {header && (
            <Modal.Header borderBottomWidth="0">{header}</Modal.Header>
          )}
        </HStack>
        <Modal.Body p={0}>{children}</Modal.Body>
        {footer && footer}
      </Modal.Content>
    </Modal>
  );
};

export default ModalBase;
